import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
// import { updateAALForm } from "../../../redux/fui";
// import { StyledTypographyMessage } from "../FuiStyles";
import { checkWBSECode, checkLicenses, checkPOCname, createMaxDate } from "./CommonFunctions";
import GeneralForm from "./GeneralForm";
import * as FormField from "./IndividualFormFields";
import * as fuiRedux from "../../../redux/fui/index";
import * as PlatformFormField from "./IndividualFormFields";
import { CommonDialog, CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { isValid } from "date-fns";
import { FlashOnRounded, FormatColorReset } from "@material-ui/icons";
import {
  fetchExternalClientDetails,
  checkIsWBSEValid
} from "../../../redux/fui/index";
import { Grid, FormControlLabel, Radio, DialogActions } from "@material-ui/core";
import {
  StyledRadioGroup,
  TopRadioWrapper,
  ConfigurationFormLabel,
} from "../FuiStyles";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
/**
 * Automation Anywhere Licenses Form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */
const AutomationAnywhereLicenses = ({
  history, // get route history
  values, // the value would be changed by user's input
  updateAALForm, //the function to update AALForm values which is from redux
  getNotesValue,
  notesValidations,
  setIsAllValid,
  externalClientData,
  isExternalClientLoading,
  externalClientError,
  fetchExternalClientDetails,
  configurationType,
  createdBy,
  formClickSubmit,
  checkIsWBSEValid,
  isWBSEValid, // this value shows whether the WBSE is valid or not from redux
  isLoading
}) => {
  const config = configurationType === "quick";
  // check whether WBSECode, ControlRoomLicenses, BotRunnerLicenses, BotCreatorLicenses are valid
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
  // check whether WBSECode is equal to MD & I WBSE
  const [isNoteVisible, setNoteVisible] = useState(true);
  const [isWBSECodeMDIValid, setIsWBSECodeMDIValid] = useState(true);
  const [isProjectNameValid, setIsProjectNameValid] = useState(true);
  const [isControlRoomLicensesValid, setIsControlRoomLicensesValid] = useState(
    true
  );
  const [isBotRunnerLicensesValid, setIsBotRunnerLicensesValid] = useState(
    true
  );
  const [isBotCreatorLicensesValid, setIsBotCreatorLicensesValid] = useState(
    true
  );
  const [sapContractCodeLength, setSapContractCodeLength] = useState(0);
  const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
  const [env, setEnv] = useState("");
  const [isPocvalid, setPocvalid] = useState(true);
  const [isPlanInputValid, setIsPlanInputValid] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const handleContractAvailabilityChange = (event) => {
    const value = event.target.value;
    setIsChecked(value === "yes");
    //updateAALForm("IsContractIdAvailable", value);
    if (value === "no") {
      updateAALForm("IsContractIdAvailable", "no")
      updateAALForm("SAPContractID", "0000000000")
      updateAALForm("EndToEndUId", "")
      setSapContractCodeLength(10)
      setPocvalid(false);
    } else {
      setPocvalid(true);
      updateAALForm("SAPContractID", "")
      updateAALForm("ClientName", "")
      updateAALForm("EndToEndUId", "")
      setSapContractCodeLength(0)
    }
  };


  if (config) {
    //updateAALForm("ClientName", "")
    updateAALForm("EndToEndUId", "")
    updateAALForm("Company", "")
    updateAALForm("AvanadeCountry", "")
    updateAALForm("AccentureCountry", "")
    updateAALForm("ContractAvailabilityDate", "")
  }

  if (!config) {
    if (externalClientData.length > 0) {
      updateAALForm("ClientName", externalClientData[0])
      updateAALForm("EndToEndUId", externalClientData[1])
      if (externalClientData[2] !== undefined)
        updateAALForm("Company", externalClientData[2])
      if (externalClientData[3] !== undefined)
        updateAALForm("AvanadeCountry", externalClientData[3])
      if (externalClientData[4] !== undefined)
        updateAALForm("AccentureCountry", externalClientData[4])
      if (isChecked && externalClientData[5] !== undefined)
        updateAALForm("GDPR", externalClientData[5] ? "yes" : "no")
      updateAALForm("ContractAvailabilityDate", "")
      updateAALForm("IsContractIdAvailable", "yes")
    }
  }

  // change validation status
  useEffect(() => {
    setIsAllValid(
      isWBSEValid && isWBSECodeMDIValid && isProjectNameValid &&
        isControlRoomLicensesValid && !config ? sapContractCodeLength == 10 : sapContractCodeLength == 0 && !externalClientError &&
        isBotCreatorLicensesValid &&
        isBotRunnerLicensesValid && isTeamNameSelected && isPocvalid
    );
  });
  updateAALForm("ConfigurationType", configurationType);
  // get user's input
  const handleChange = (event, fieldName) => {
    if (fieldName === "TeamName") {
      if (event !== undefined || event !== null) {
        updateAALForm(fieldName, event);
        setIsTeamNameSelected(true);
        if (values.TeamName !== "Others") {
          updateAALForm("TeamNameOthers", "")
        }
      }
    } else {
      const value = event.target.value;
      event.preventDefault();
      updateAALForm(fieldName, value);
      if (fieldName === "WBSEcode") {
        const wbsevalue = value.toUpperCase()
        if (wbsevalue.trim() === "CBYDQ001") {
          setIsWBSECodeMDIValid(false)
        }
        // setIsWBSECodeValid(checkWBSECode(value));
        const isWBSEFormatValid = checkWBSECode(value);
        if (isWBSEFormatValid) {
          checkIsWBSEValid(value)
        }
      }
      if (fieldName === "Pocdetails") {
        setPocvalid(checkPOCname(value));
      }
      if (fieldName === "ProjectName") {
        if (value.length > 32 || value.length < 3) {
          setIsProjectNameValid(false)
        } else {
          setIsProjectNameValid(true)
        }
      }
      if (fieldName === "NumOfControlRoomlicenses") {
        setIsControlRoomLicensesValid(checkLicenses(value));
      }
      if (fieldName === "NumOfRunnerlicenses") {
        setIsBotRunnerLicensesValid(checkLicenses(value));
      }
      if (fieldName === "NumOfDeveloperlicenses") {
        setIsBotCreatorLicensesValid(checkLicenses(value));
      }
      if (fieldName === "SAPContractID") {
        let sapLength = value.length
        setSapContractCodeLength(sapLength)
        if (sapLength == 10) {
          fetchExternalClientDetails(value)
        }
      }
      if (fieldName === "GDPR" && value === "yes") {
        updateAALForm("DeploymentRegion", "");
      }
      if (fieldName === "DataClassification") {
        if (value === "Client-Production" || value === "Internal-Production") {
          setEnv("Production")
        } else if (value === "Client-NonProduction") {
          setEnv("Test")
          updateAALForm("Tier", "")
        } else if (value === "AppTeam-Development") {
          setEnv("Dev")
          updateAALForm("Tier", "")
        } else if (value === "AppTeam-Testing") {
          setEnv("Test")
          updateAALForm("Tier", "")
        } else {
          setEnv("")
          updateAALForm("Tier", "")
        }
      }

      if (fieldName === "RequestNotes") {
        if (value.length > 0 && value.length < 247) {
          getNotesValue({ emptyString: false, maxLength: false });
        } else if (value.length === 0) {
          getNotesValue({ emptyString: true, maxLength: false });
        } else if (value.length > 246) {
          getNotesValue({ emptyString: false, maxLength: true });
        }
      }
    }
  }

  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";

  const handleChangeMobileNo = (event, fieldName) => {
    const re = /^[0-9]{0,}$/;
    const value = event.target.value;
    re.test(value) && updateAALForm(fieldName, value);
  };
  // getSelectedEnvironment(env);
  updateAALForm("Environment", env);
  updateAALForm("RITM", "N/A");

  //form validation
  const validateInputFields = (step) => {
    let ispass = true;
    const fieldsRequired = {
      'step0': [
        'ProjectName',
        'WBSEcode',
        'DataClassification',
        'TeamName',
        'RequestNotes',
      ],

      'step1': [
        'DeploymentRegion',
      ],

      'step2': [
        'InstanceType',
        'InstanceName',
        'LicenseUsage',
        //'InstanceUrl',
        'AAversion',
        'NumOfControlRoomlicenses',
        'NumOfControlRoomlicenses',
        'NumOfDeveloperlicenses',
        'NumOfRunnerlicenses'
      ]
    }

    if (config) {
      //fieldsRequired['step0'].push('ClientNameInternal');
    } else {
      if (isChecked)
        fieldsRequired['step0'].push('SAPContractID');
      else {
        fieldsRequired['step0'].push('Pocdetails', 'ClientNameInternal');
      }
    }

    for (const fieldname of fieldsRequired[step]) {
      if (fieldname === "WBSEcode" && !isWBSEValid) {
        document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "2px solid #E20000";
        ispass = false;
      } else if (values[fieldname] === "") {
        document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "2px solid #E20000";
        ispass = false;
      } else {
        document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "";
      }
    }

    if (step === 'step2' && ispass)
      formClickSubmit();
    else
      return ispass;
  }


  return (
    <>
      <GeneralForm
        isPlanInputValid={isPlanInputValid}
        FormId={10}
        validateInputFields={validateInputFields}
        ClientContractFields={

          <div>
            {!config ?
              <TopRadioWrapper>
                <ConfigurationFormLabel component="legend">
                  Is a contract ID available?
                </ConfigurationFormLabel>


                <StyledRadioGroup
                  aria-label="contract-available"
                  name="contract-available"
                  value={isChecked ? "yes" : "no"}
                  onChange={handleContractAvailabilityChange}
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio color="primary" />}
                    label="YES"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio color="primary" />}
                    label="NO"
                  />
                </StyledRadioGroup>
              </TopRadioWrapper>
              : ""
            }
            {(!isChecked && !config) &&
              <div style={{ fontSize: "small", color: "#0041F0" }}>
                <em>
                  To proceed with provisioning without a Contract ID, please provide the following mandatory details
                </em>
                <ul>
                  <li>WBSE Code (used for chargeback if contract is not provided)</li>
                  <li>Opportunity ID (for deal tracking and reference)</li>
                  <li>Expected Contract Availability Date (must be within 28 days)</li>
                  <li>Client Point of Contact (name and email for contract follow-up)</li>
                </ul>
              </div>
            }
            < div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >
                {(!config && isChecked) ?
                  <Grid item xs={4}>
                    {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                  </Grid>
                  : (!config && !isChecked) ?
                    <Grid item xs={4}>
                      {FormField.Pocvalid(handleChange, values, isPocvalid)}
                    </Grid>
                    : <></>
                }
                {(!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError) &&
                  <Grid item xs={4}>
                    {PlatformFormField.ClientNamePlatformField(
                      values,
                      handleChange,
                      externalClientData[0]
                    )}
                  </Grid>
                }
                {!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError && (
                    <Grid item xs={4}>
                      {PlatformFormField.EndToEndUIdPlatformField(
                        values,
                        handleChange,
                        externalClientData[1]
                      )}
                    </Grid>
                  )}
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    {FormField.ClientNamePlatformInternal(handleChange, values)}
                  </Grid >
                }
                <Grid item xs={4}>
                  {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSECodeMDIValid, isWBSEValid, isLoading)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.TeamNamesField(handleChange, values, isTeamNameSelected)}
                </Grid >
                {values.TeamName === "Others" &&
                  <Grid item xs={4}>
                    {FormField.TeamNameOthers(handleChange, values)}
                  </Grid >
                }
                <Grid item xs={4}>
                  {FormField.DataClassificationField(handleChange, values, configurationType)}
                </Grid>
                <Grid item xs={12}>
                  {FormField.RequestNotesField(handleChange, values, notesValidations)}
                </Grid>

              </Grid>
            </div>
          </div>
        }
        EnvironmentFields={
          <div>
            <div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >
                <Grid item xs={6}>
                  {FormField.DeploymentRegionField(values)}
                </Grid>

              </Grid>
            </div>
          </div>
        }

        ApplicationFields={
          <div style={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
            >
              <Grid item xs={4}>
                {FormField.InstanceTypeField(handleChange, values)}
              </Grid>

              {values.ChooseNewOrExistingInstance === "Existing" &&
                <Grid item xs={4}>
                  {FormField.ChooseInstanceField(values)}

                </Grid>}

              <Grid item xs={4}>
                {FormField.InstanceNameField(values)}
              </Grid>

              {values.ChooseNewOrExistingInstance === "existing" &&
                <Grid item xs={4}>
                  {FormField.InstanceUrlField(values)}
                </Grid>}

              <Grid item xs={4}>
                {FormField.LicenseUsageField(handleChange, values)}
              </Grid>

              <Grid item xs={4}>
                {FormField.AutomationAnywhereVersionField(handleChange, values)}
              </Grid>

              <Grid item xs={4}>
                {FormField.ControlRoomLicensesField(
                  handleChange,
                  values,
                  isControlRoomLicensesValid
                )}</Grid>
              <Grid item xs={4}>
                {FormField.BotRunnerLicenseField(
                  handleChange,
                  values,
                  isBotRunnerLicensesValid
                )}</Grid>
              <Grid item xs={4}>
                {FormField.BotCreatorLicenseField(
                  handleChange,
                  values,
                  isBotCreatorLicensesValid
                )}</Grid>
            </Grid>
          </div>
        }
        history={history}
      ></GeneralForm>
      {!isChecked && (
        <CommonDialogV2
          open={isNoteVisible}
          onClose={() => setNoteVisible(false)}
          title={"Note"}
          textContent={
            <div>
              <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
              <ul>
                <li>
                  Provisioned services will be automatically stopped
                </li>
                <li>
                  Cost recovery will be initiated using the provided WBSE code
                </li>
              </ul>
            </div>
          }
          dialogActions={
            <DialogActions>
              <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
            </DialogActions>
          }
        ></CommonDialogV2>
      )}
    </>
  );
};

const MSTP = (state, ownProps) => ({
  email: state.auth.userDetails.email,
  configurationType: state.fui.configurationType,
  externalClientData: state.fui.externalClientData,
  externalClientError: state.fui.externalClientError,
  isExternalClientLoading: state.fui.isExternalClientLoading,
  values: state.fui.AALForm,
  isWBSEValid: state.fui.isWBSEValid,
});

export default connect(MSTP, { updateAALForm: fuiRedux.updateAALForm, fetchExternalClientDetails, checkIsWBSEValid })(
  withRouter(AutomationAnywhereLicenses)
);
